import angular from 'angular'

angular
  .module('ggs.utils')
  .factory('waitAngular', waitAngularProvider)
  .factory('waitAngularCallback', waitAngularCallbackProvider)

function waitAngularProvider($q, $rootScope) {
  const applyAsync = $rootScope.$applyAsync.bind($rootScope)
  return function waitAngular(value) {
    return value === undefined
      ? $q(applyAsync)
      : $q(applyAsync).then(() => value)
  }
}

function waitAngularCallbackProvider($q, $rootScope) {
  const applyAsync = $rootScope.$applyAsync.bind($rootScope)
  return function waitAngularCallback(callback) {
    return $q(applyAsync).then(callback)
  }
}
